import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/services/api';
import type { PublicProfileData } from '@/types/dashboard';

export function usePublicProfile(handle: string | undefined) {
  return useQuery<PublicProfileData>({
    queryKey: ['profile', handle],
    queryFn: () => dashboardApi.getPublicProfile(handle as string),
    enabled: !!handle,
    retry: false,
    refetchOnWindowFocus: true,
  });
}
